import { Row, Col, Divider } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { languages } from "../../../utils/helpers/constants";
import { getTranslations } from "../../../utils/helpers/translations";
import FieldBuilder from "../../form-components/field-builder";
import MainForm from "../../form-components/main-form";
import Spin from "../../general/antd/spin";
import UnitContext from "../../../context/unit/context";
import UnitContextProvider from "../../../context/unit/provider";
import { IUpdateUnit } from "../../../models/unit/request";

const Form = () => {
  const { t } = useTranslation();
  const { details, actions, loading } = useContext(UnitContext);
  const { id } = useParams();

  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, []);
  return (
    <MainForm
      onSubmit={(data) => {
        details
          ? actions.updateUnit(details?.id, data)
          : actions.createUnit(data);
      }}
      title={details ? t("update_unit") : t("add_unit")}
      defaultValues={
        {
          factor_accounting_system: details?.factor_accounting_system,
          name: getTranslations(details?.translations?.name),
          note: getTranslations(details?.translations?.note),
        } as IUpdateUnit
      }
    >
      {loading.includes("details") ? (
        <div style={{ height: "50vh" }}>
          <Spin />
        </div>
      ) : (
        <>
          <Row gutter={[16, 8]}>
            {languages?.map((lang, index) => {
              return (
                <Col span={12}>
                  <FieldBuilder
                    key={index}
                    name={`name[${lang?.code}]`}
                    label={`${t("name")} (${lang?.name})`}
                    input={{ type: "text" }}
                    rules={{ required: true }}
                  />
                </Col>
              );
            })}

            {languages?.map((lang, index) => {
              return (
                <Col span={12}>
                  <FieldBuilder
                    key={index}
                    name={`note[${lang?.code}]`}
                    label={`${t("note")} (${lang?.name})`}
                    input={{ type: "text-area", value: " s" }}
                    rules={{ required: false }}
                  />
                </Col>
              );
            })}
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
              <FieldBuilder
                name={`factor_accounting_system`}
                label={`${t("factor_accounting_system")}`}
                input={{ type: "text" }}
                rules={{ required: true }}
              />
            </Col>
          </Row>
        </>
      )}
    </MainForm>
  );
};

const UnitForm = () => {
  return (
    <UnitContextProvider>
      <Form />
    </UnitContextProvider>
  );
};
export default UnitForm;
